import { BaseRequest } from '@/network/requests/BaseRequest';
import { defect_analyze } from '@/interfaces/defect_analyze';

export const defectAnalyzeRequest = BaseRequest.build<defect_analyze>('defect_analyze');